import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_ARENDA_VIDEO: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Профессиональные операторы снимают мероприятие с&nbsp;нескольких камер, посылая на&nbsp;видеомикшер разные планы и&nbsp;ракурсы происходящего',
            alt: 'Передача с нескольких камер изображения на видеомикшер',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/camera-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/camera.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/camera-drawing.webp',
            image_webp: '/assets/images/ui/how-it-work/webp/camera.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Режиссер трансляции выбирает нужные ракурсы и&nbsp;формирует красивую картинку, совмещая с&nbsp;выводом презентаций, титрами и&nbsp;онлайн участниками по&nbsp;сценарию заказчика',
            alt: 'Формирование красивой картинки по сценарию заказчика',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-npg/filmmaker-with-monitor-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-npg/filmmaker-with-monitor.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/filmmaker-with-monitor-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/filmmaker-with-monitor.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. Видео в&nbsp;разных комбинациях можно в&nbsp;реальном времени выводить на&nbsp;экраны зала, мониторы выступающих, а&nbsp;так&nbsp;же в&nbsp;интернет на&nbsp;любые платформы и&nbsp;соцсети.',
            alt: 'Вывод видео в реальном времени на экраны зала',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/video-display-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/video-display.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/video-display-drawing.webp',
            image_webp: '/assets/images/ui/how-it-work/webp/video-display.webp',
        },
    ],
    video: {
        title: 'Как используется',
        name: 'А как в работе',
        description: 'Видеотрансляция на мероприятии с оборудованием от Cromi',
        width: 420,
        height: 307,
        video_preview:
            '/assets/images/usage/conference-system/jpg-png/negotiating-table.jpg',
        video_preview_webp:
            '/assets/images/usage/conference-system/webp/negotiating-table.webp',
        duration: '1:53',
        link: '73d10bcde26b9a3ba106c58fa37cecc5',
    },
}

export default HOW_IT_WORK_ARENDA_VIDEO
